import { render } from "./dashboardView.vue?vue&type=template&id=413e3b74"
import script from "./dashboardView.vue?vue&type=script&lang=js"
export * from "./dashboardView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__